import { defineComponent, nextTick, onMounted, onUnmounted, PropType, ref } from "vue";
import InputText from "../../forms/InputText";
import Utils from "../../utils/Utils";
import Offers from "../../components/Offers";
import { OfferJson } from "../../OrderForm";
import { SmeOrderJson } from "../../utils/SmeUtils";
import Swiper from "swiper";
import { Autoplay } from "swiper/modules";
import Site from "../../Site";
import Tracking from "../../utils/Tracking";

export default defineComponent({
    components: {
        InputText,
        Offers,
    },

    template: `
        <div ref="el" class="vsme">
            <div class="vsme__section1">
                <div v-if="html" v-html="html.header"></div>
            </div>

            <div v-if="html" v-html="html.body"></div>
        </div>

        <Teleport to=".preheader">
            <div class="preheaderbar">
                <b>0,479 zł/kWh</b> do końca 2025 r. z kodem TANIEJ25
            </div>
        </Teleport>

        <teleport to=".footer-terms__addons">
            *Przedstawione powyżej informacje nie stanowią oferty w rozumieniu Art. 66 par. 1 Kodeksu Cywilnego.<br><br>
            **Przy wyrażeniu zgody na e-fakturę i komunikację marketingową.
        </teleport>
    `,

    emits: [
    ],

    props: {
        options: { type: Object as PropType<SmeOrderJson>, required: true },
    },

    setup(props, ctx) {
        const html = ref(null);
        const offers = ref(null as OfferJson[]);

        async function reload() {
            html.value = (await Utils.get('/api/pages/sme-home')).html;

            nextTick(() => {
                const s = new Swiper('.partners__slider', {
                    modules: [Autoplay],

                    slidesPerView: 1,

                    autoplay: {
                        delay: 2000,
                    },

                    breakpoints: {
                        768: {
                            slidesPerView: 'auto',
                            enabled: false,
                        },
                    },
                });

                new Swiper('.reviewboxlist__slider', {
                    slidesPerView: 'auto',

                    breakpoints: {
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 0,
                        },
                    },
                });

                Site.initFaqPane($('.faqpane'));

                Tracking.link('.js-sme-home-savings', 'b2bsme_click_checksavings');
                Tracking.link('.js-sme-home-contact', 'b2bsme_click_contactrequest');
                Tracking.link('.js-sme-home-offer', 'b2bsme_click_checkb2coffer');
            });
        }

        function recalc() {
            const st = $(document).scrollTop();

            const $header = $('.header__inner');
            const $preheader = $('.preheader');
            const $bar = $('.vhome__uploadbar');
            const $barinner = $('.vhome__uploadbar-inner');
            const top = $bar.offset().top;
            const sy = $(window).scrollTop();
            const vw = window.innerWidth;

            const htop = (vw < 768 ? $header.height() : 0);
            const sticky = st > top - htop;

            $('body').toggleClass('body--float', sy > $preheader.height());
            $('.header__wrap').css('top', vw < 768 && sy < 25 ? 25 - sy : '0');
            $barinner.css('top', htop);

            $bar.toggleClass('vhome__uploadbar--sticky', sticky);
        }

        onMounted(async () => {
            await reload();

            $(document).on('scroll', () => {
                recalc();
            });

            $(window).on('resize', () => {
                recalc();
            });

            recalc();

            $('.header').addClass('header--preheader header--preheadernosticky');
        });

        onUnmounted(() => {
            $('.header').removeClass('header--preheader header--preheadernosticky');
        });

        Utils.attachBodyClass(['body--vsme']);

        return {
            html,
            offers,

            reload,
        };
    },
});
